module.exports = __webpack_public_path__ + "img/phone.743c2e9b.svg";